// src/pages/Home.jsx
import React, { useEffect, useState } from "react";
import "./Home.css";
import EnquiryPopup from "../components/EnquiryPopup";
import { FaWpforms } from "react-icons/fa";


import hero from "../assets/building-image-ai.png";
import homeAiClass from "../assets/digital-class.JPG";
import campus from "../assets/campus photo.jpg";
import homeRobotics from "../assets/home-robot.jfif";
import homeSwimming from "../assets/home-pool.jfif";
import homeBasketball from "../assets/home-basketball.jfif";
import homePickleball from "../assets/pickle-ball.jpeg";
import homeBadminton from "../assets/badminton-try-2.jpeg";
import homeChess from "../assets/home-chess.jfif";
import homeCarrom from "../assets/home-carrom.8d622c3f6cf0747ba54e_compressed.webp";
import homeTabletennis from "../assets/tt-image-2.png";

const slides = [
  {
    id: 0,
    img: hero,
    title: "WELCOME TO VVCMS",
    subtitle: "Where curiosity meets character in every classroom and corridor.",
    body:
      "At Vivek Vardhini Creative Minds School, children learn to ask bold questions, think independently and grow into kind, responsible individuals.",
    caption: "A joyful, engaging learning environment.",
  },
  {
    id: 1,
    img: homeAiClass,
    title: "SMART, FUTURE-READY CLASSROOMS",
    subtitle: "Smart AC classrooms that keep every learner focused and comfortable.",
    body:
      "Interactive boards, digital content and activity-based teaching make concepts come alive and keep students excited about learning.",
    caption: "Smart AC classrooms for focused learning.",
  },
  {
    id: 2,
    img: campus,
    title: "SAFE & VIBRANT SCHOOL CAMPUS",
    subtitle: "A safe, vibrant campus where every child finds space to explore.",
    body:
      "From morning assemblies to club activities, the campus is designed to encourage collaboration, discipline and a strong sense of belonging.",
    caption: "Safe and vibrant school campus.",
  },
  {
    id: 3,
    img: homeRobotics,
    title: "CREATIVE MINDS, STRONG VALUES",
    subtitle: "Spaces that inspire creativity, confidence and collaboration.",
    body:
      "Whether it is art, music, robotics or sports, students get platforms to discover their talents and shine beyond textbooks.",
    caption: "Spaces that inspire creativity & collaboration.",
  },
  {
    id: 4,
    img: homeSwimming,
    title: "CONFIDENCE IN EVERY STROKE",
    subtitle:
      "A temperature-controlled pool where children learn discipline, safety and joy in the water.",
    body:
      "Our professionally designed swimming programme helps students overcome fear, build stamina and learn life-saving skills in a safe, supervised environment.",
    caption: "Building strength, stamina and water confidence.",
  },
  {
    id: 5,
    img: homeBasketball,
    title: "TEAMWORK ON AND OFF THE COURT",
    subtitle: "Basketball that teaches strategy, sportsmanship and never giving up.",
    body:
      "From drills to friendly matches, our basketball court is a space where students learn to communicate, trust their teammates and push their limits with a sporting spirit.",
    caption: "Where teamwork, hustle and heart come together.",
  },
  {
    id: 6,
    img: homePickleball,
    title: "FAST, FUN & FAMILY-FRIENDLY SPORT",
    subtitle: "Pickleball courts that keep children active, agile and always smiling.",
    body:
      "With simple rules and fast-paced rallies, pickleball helps students improve reflexes, coordination and fitness while enjoying a game they can play for life.",
    caption: "A modern sport for quick feet and quicker minds.",
  },
  {
    id: 7,
    img: homeBadminton,
    title: "LIGHT FEET, SHARP FOCUS",
    subtitle: "Badminton that sharpens the mind as much as it trains the body.",
    body:
      "Our badminton sessions help students develop agility, focus and precision through structured coaching, friendly games and inter-house tournaments.",
    caption: "Refining focus, footwork and fitness.",
  },
  {
    id: 8,
    img: homeChess,
    title: "THINK LIKE A CHAMPION",
    subtitle: "Chess that trains young minds to plan ahead and think deeply.",
    body:
      "Through regular practice and guided play, students learn patience, strategy and decision-making skills that translate into better problem solving in the classroom and in life.",
    caption: "Quiet boards, powerful minds at work.",
  },
  {
    id: 9,
    img: homeCarrom,
    title: "FOCUS IN EVERY STRIKE",
    subtitle: "Carrom corners where friendships, focus and fun come together.",
    body:
      "Carrom builds concentration, hand–eye coordination and social bonding as students learn to aim carefully, play fairly and enjoy relaxed indoor competition.",
    caption: "Simple boards, serious concentration.",
  },
  {
    id: 10,
    img: homeTabletennis,
    title: "SPEED, SPIN & SMART REACTIONS",
    subtitle: "Table tennis that keeps minds alert and bodies active.",
    body:
      "Fast rallies and quick returns help students develop reflexes, coordination and strategic thinking, all while having fun in a safe indoor setting.",
    caption: "Quick thinking, quicker rallies.",
  },
];

// Typewriter component
const TypewriterText = ({
  text,
  as: Tag = "p",
  className = "",
  speed = 25,
  trigger,
}) => {
  const [displayed, setDisplayed] = useState("");

  useEffect(() => {
    setDisplayed("");
    if (!text) return;

    let i = 0;
    const interval = setInterval(() => {
      i += 1;
      setDisplayed(text.slice(0, i));
      if (i >= text.length) clearInterval(interval);
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed, trigger]);

  return <Tag className={className}>{displayed}</Tag>;
};

const Home = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    const interval = setInterval(
      () => setActiveIndex((prev) => (prev + 1) % slides.length),
      11000
    );
    return () => clearInterval(interval);
  }, []);

  const currentSlide = slides[activeIndex];

  return (
    <div className="hero-section" id="home">
      {/* BACKGROUND */}
      <div className="hero-bg">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`hero-bg-slide ${
              index === activeIndex ? "hero-bg-slide-active" : ""
            }`}
          >
            <img src={slide.img} alt={`Campus slide ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* OVERLAY */}
      <div className="hero-overlay" />

      {/* FOREGROUND */}
      <div className="hero-inner" data-aos="fade-up">
        <div className="hero-text">
          <TypewriterText
            as="h2"
            className="hero-title"
            text={currentSlide.title}
            speed={90}
            trigger={activeIndex}
          />
          <TypewriterText
            className="hero-subtitle"
            text={currentSlide.subtitle}
            speed={55}
            trigger={activeIndex}
          />
          <TypewriterText
            className="hero-body"
            text={currentSlide.body}
            speed={50}
            trigger={activeIndex}
          />
          <TypewriterText
            className="hero-caption-pill"
            text={currentSlide.caption}
            speed={60}
            trigger={activeIndex}
          />
        </div>
      </div>

      {/* FIXED ENQUIRY BUTTON */}
      <div className="enquiry-button-wrapper">
        <button
  className="enquiry-button"
  onClick={() => setIsPopupOpen(true)}
  aria-label="Open enquiry form"
>
  <FaWpforms className="enquiry-icon" />
  <span>Enquiry</span>
</button>

      </div>

      {isPopupOpen && <EnquiryPopup onClose={() => setIsPopupOpen(false)} />}
    </div>
  );
};

export default Home;
